import _get from "lodash.get";
import { jarvisOnestockDashboardConstants } from "./jarvisOnestockDashboardConstants";

const jarvisOnestockDashboardParser = {};

jarvisOnestockDashboardParser.onestockDashboardStats = (res) => {
  if (res && res.response) {
    res = res.response;
  }

  if (!res || !Object.keys(res).length) {
    return {};
  }

  let data = {
    closedCalls: _get(res, "closedCalls", null),
    // investedAmount: _get(res, "investedAmount", null),
    openCalls: _get(res, "openCalls", null),
    profitBooked: _get(res, "profitBooked", null),
    profitBookedPercentage: _get(res, "profitBookedPercentage", null),
    totalRecommendations: _get(res, "totalRecommendations", null),
    overAllProfitAveragePercentage: _get(res, "overAllProfitAveragePercentage", null),

    investedAmount: _get(res, "investedAmount", null),
    currentValue: _get(res, "currentValue", null),
    customerTotalReturns: _get(res, "customerTotalReturns", null),
    customerTotalReturnsPercentage: _get(res, "customerTotalReturnsPercentage", null),
    customerUnrealisedReturnsValue: _get(res, "customerUnrealisedReturnsValue", null),
    customerUnrealisedReturnsPercentage: _get(res, "customerUnrealisedReturnsPercentage", null),
    customerRealisedReturnsValue: _get(res, "customerRealisedReturnsValue", null),
    customerRealisedReturnsPercentage: _get(res, "customerRealisedReturnsPercentage", null),
    executedCalls: _get(res, "customerExecutedCalls", null),

    totalCalls: _get(res, "totalRecommendations", null),
    totalReturnsPercentage: _get(res, "totalReturnsPercentage", null),
    unrealisedReturnsPercentage: _get(res, "unrealisedReturnsPercentage", null),
    realisedReturnsPercentage: _get(res, "realisedReturnsPercentage", null),
  }
  return data;
};

jarvisOnestockDashboardParser.onestockDashboardStatsV2 = (res) => {
  // unwrap axios-style response
  const response = res?.data || res;

  if (!response?.data) {
    return {};
  }

  const { jarvisInvestment = {}, myInvestment = {} } = response.data;

  const parseInvestment = (investment = {}) => {
    const { overall = {}, monthWise = [] } = investment;

    return {
      overall: {
        totalCalls: overall.totalCalls ?? 0,
        avgAmountInvested: overall.avgAmountInvested ?? 0,
        openCalls: overall.openCalls ?? 0,
        closedCalls: overall.closedCalls ?? 0,
        openCallReturns: overall.openCallReturns ?? 0,
        closedCallReturns: overall.closedCallReturns ?? 0,
        avgHoldingDays: overall.avgHoldingDays ?? 0,
        totalReturns: overall.totalReturns ?? 0,
        pl: overall.pl ?? 0,
        niftyReturns: overall.niftyReturns ?? 0,
      },

      monthWise: monthWise.map((m) => ({
        month: m.month,
        totalCalls: m.totalCalls ?? 0,
        avgAmountInvested: m.avgAmountInvested ?? 0,
        openCalls: m.openCalls ?? 0,
        closedCalls: m.closedCalls ?? 0,
        openCallReturns: m.openCallReturns ?? 0,
        closedCallReturns: m.closedCallReturns ?? 0,
        avgHoldingDays: m.avgHoldingDays ?? 0,
        totalReturns: m.totalReturns ?? 0,
        pl: m.pl ?? 0,
        niftyReturns: m.niftyReturns ?? 0, // null → 0 handled
      })),
    };
  };

  return {
    jarvisInvestment: parseInvestment(jarvisInvestment),
    myInvestment: parseInvestment(myInvestment),
  };
};


jarvisOnestockDashboardParser.dashboardReveal = (res) => {
  const response =
    res?.response ||
    res?.data?.response ||
    res?.data ||
    res;

  if (!response || !Object.keys(response).length) {
    return {};
  }

  const toScalarLtp = (raw) => {
    if (raw == null) return null;
    if (Array.isArray(raw)) {
      const first = raw.find((x) => x != null && x !== "");
      return first == null ? null : Number(first);
    }
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  };

  const parseStock = (stock = {}) => {
    const rawLtp = _get(stock, "LTP", _get(stock, "lTP", null));
    const ltp = toScalarLtp(rawLtp);

    return {
    stockId: _get(stock, "stockId", null),
    stockSymbol: _get(stock, "stockSymbol", null),
    stockName: _get(stock, "stockName", null),
    stockExchange: _get(stock, "stockExchange", null),
    reason: _get(stock, "reason", null),
    marketCap: _get(stock, "marketCap", null),
    riskScore: _get(stock, "riskScore", null),
    oneYearCAGRPercentage: _get(stock, "oneYearCAGRPercentage", null),

    LTP: ltp,
    lTP: ltp,

    targetPrice: _get(stock, "targetPrice", null),
    targetPricePercentage: _get(stock, "targetPricePercentage", null),

    technicalScorePercentage: _get(stock, "technicalScorePercentage", null),
    fundamentalScorePercentage: _get(stock, "fundamentalScorePercentage", null),
    overallAIScorePercentage: _get(stock, "overallAIScorePercentage", null),
    sentimentScorePercentage: _get(stock, "sentimentScorePercentage", null),

    weekHigh: _get(stock, "52WeekHigh", null),
    weekHighPercentage: _get(stock, "52WeekHighPercentage", null),
    weekLow: _get(stock, "52WeekLow", null),
    weekLowPercentage: _get(stock, "52WeekLowPercentage", null),

    oneStockCallId: _get(stock, "oneStockCallId", null),
    isin: _get(stock, "isin", null),
    tagStock: _get(stock, "tagStock", []),
    };
  };

  const rawStocks = response.stocks;
  let stockList = [];
  if (Array.isArray(rawStocks)) {
    stockList = rawStocks;
  } else if (rawStocks && typeof rawStocks === "object") {
    stockList = Object.values(rawStocks);
  }

  const stocks =
    stockList.length > 0
      ? stockList.map(parseStock)
      : [parseStock(response)];

  return {
    revealStatus: _get(response, "revealStatus", null),
    revealNote: _get(response, "revealNote", null),
    revealTime: _get(response, "revealTime", null),

    // important
    stocks,

    // fallback for old UI parts
    ...stocks[0],
  };
};



export { jarvisOnestockDashboardParser };
